var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.showTop)?_c('Nav',{key:_vm.$route.fullPath}):_vm._e(),_c('div',{staticClass:"main__content"},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }